import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { UsageService } from './usage.service';

/**
 * Angular's own error handling, plus a count of the error (name and message only) for the usage report. The usage
 * service is looked up when an error happens: the error handler is built before almost everything else.
 */
@Injectable()
export class UsageErrorHandler extends ErrorHandler {
  constructor(private readonly injector: Injector) {
    super();
  }

  override handleError(error: unknown): void {
    try {
      this.injector.get(UsageService).error(error);
    } catch {
      // Counting an error must never hide it.
    }
    super.handleError(error);
  }
}
